import * as React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { getServerBaseUrl } from "../../utils/portConfig";

function Login({ onLogin }) {
  const navigate = useNavigate(); // useNavigate 사용

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const API_SERVER_URL = getServerBaseUrl();

    // 로그인 정보를 포함한 객체 생성
    const loginInfo = {
      userid: data.get("id"),
      password: data.get("password"),
      ipAddress: window.location.hostname, // IP 주소 (혹은 클라이언트의 IP 주소를 가져오는 로직)
      loginTime: new Date().toISOString(), // 현재 시간
      userAgent: navigator.userAgent, // 브라우저 정보
    };

    try {
      const response = await axios.post(API_SERVER_URL + "/api/login", loginInfo);

      if (response.status === 200 && response.data.roles[0] !== "Patient") {
        // 게시판에서 사용:  사용자 id 저장
        localStorage.setItem("userid", data.get("id"));

        // 서버에서 받은 토큰을 로컬 스토리지에 저장
        localStorage.setItem("token", response.data.token);

        // 서버에서 받은 권한을 로컬 스토리지에 저장
        localStorage.setItem("auth", response.data.roles[0]);

        // 서버에서 받은 사용자 id(숫자)를 로컬 스토리지에 저장
        localStorage.setItem("id", response.data.id);

        localStorage.setItem("active", 1);

        if (response.data.roles[0] == "Nurse" || response.data.roles[0] == "Doctor") {
          localStorage.setItem("hospitalId", response.data.hospitalId);
        }

        if (response.data.token) {
          onLogin();

          if (response.data.roles[0] === "Superadmin" || response.data.roles[0] === "Admin") {
            navigate("/admin/users");
          } else {
            navigate("/");
          }
        }
      } else {
        console.error("로그인 실패");
        alert("등록되지 않은 사용자입니다.");
      }
    } catch (error) {
      console.error("로그인 요청 실패:", error);
      alert("아이디 또는 패스워드를 확인해주세요.");
    }
  };

  return (
    <ThemeProvider theme={createTheme()}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            로그인
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField margin="normal" required fullWidth id="id" label="아이디" name="id" autoComplete="id" autoFocus />
            <TextField margin="normal" required fullWidth name="password" label="비밀번호" type="password" id="password" autoComplete="current-password" />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              로그인
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default Login;
